// Packages
// Actions
import {
  applyFilters,
  toggleFilterItem,
} from "components/Stacker/actions/SearchActions"
import {
  setFilterOpenStatus,
  resetPagination,
} from "components/Stacker/actions/StackerActions"
import ClearFilter from "components/Stacker/components/ClearFilter/ClearFilter"
// Configs
import FRMC from "components/Stacker/config/FormConfig"
// Utils
import PropTypes from "prop-types"
// Components
import FilterMainCategory from "../FilterMainCategory/FilterMainCategory"
// Styles
import "./SearchFilter.scss"
import { getButtonStyles } from "components/DYStackers/styles"
import { useDispatch, useSelector } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"
import { useCallback } from "react"

function SearchFilter(props) {
  const dispatch = useDispatch()
  const { LL } = useI18nContext()
  const { selectedFilterCategory, filters, shouldShowOverlay } = props
  const initialValues = useSelector(
    (state) => state.search.filters.selectedFilterItemsFromServer
  )
  const selectedFilterItems = useSelector(
    (state) => state.search.filters.selectedFilterItems
  )
  const collapsedFilterCategories = useSelector(
    (state) => state.search.collapsedFilterCategories
  )

  const handleFilterChange = useCallback(
    (e, dataSet) => {
      dispatch(toggleFilterItem(dataSet || e.target.dataset.filterQuery))
    },
    [dispatch]
  )

  const getMainFilterCategories = () => {
    const mainCategories = filters.map((mainCategory, index) => {
      const { name } = mainCategory

      return (
        <FilterMainCategory
          //formChange={props.change}
          filterCategory={mainCategory}
          isExpanded={selectedFilterCategory === name}
          key={name}
          index={index}
          handleFilterChange={handleFilterChange}
          //handleClearSelectedFilters={handleClearSelectedFilters}
          initialValues={initialValues}
          selectedFilterItems={selectedFilterItems}
          collapsedFilterCategories={collapsedFilterCategories}
          shouldShowOverlay={shouldShowOverlay}
        />
      )
    })
    return mainCategories
  }

  const handleApplyFilters = () => {
    dispatch(resetPagination())
    dispatch(setFilterOpenStatus(false))
    dispatch(applyFilters())
  }

  return (
    <article className="SearchFilter">
      <div className="d-xl-flex category-wrapper">
        {getMainFilterCategories()}
        <div className="col-12 apply-all-filter-wrapper">
          <button
            className="c-btn apply-all-filter-btn"
            type="submit"
            onTouchStart={handleApplyFilters}
            onClick={handleApplyFilters}
            style={getButtonStyles()}
          >
            {LL.search.applyFiltersText()}
          </button>
        </div>
        <div className="text-center clear-all-filter-wrapper">
          <ClearFilter />
        </div>
      </div>
    </article>
  )
}

SearchFilter.propTypes = {
  filters: PropTypes.array.isRequired,
  selectedFilterCategory: PropTypes.string,
  shouldShowOverlay: PropTypes.bool,
  //change: PropTypes.func,
}

export default SearchFilter
